import { toLocalISO } from '@quipex/core/primitives';
import type { DocumentExportStatusResponse } from '@quipex/shared/contracts';

export function selectedExportStatusTime(
    status: DocumentExportStatusResponse,
    existing: string | undefined
): string {
    const timestamps = [
        status.createdAt,
        status.startedAt,
        status.completedAt,
        status.failedAt,
        status.expiredAt,
        existing,
    ].filter(
        (value): value is string =>
            typeof value === 'string' && Number.isFinite(Date.parse(value))
    );
    const [initial, ...remaining] = timestamps;
    if (initial === undefined) return toLocalISO();
    return remaining.reduce(
        (latest, candidate) =>
            Date.parse(candidate) > Date.parse(latest) ? candidate : latest,
        initial
    );
}
